import { useCallback, useEffect, useRef, useState } from "react";
import { accountSnapshotSchema, sendAccountCommand, type AccountCommand, type AccountSnapshot, type DiscoveryApi } from "../core/discoveryAccount";

export function useDiscoveryAccount(api: DiscoveryApi | undefined) {
  const [snapshot,setSnapshot]=useState<AccountSnapshot|null>(null);
  const [loading,setLoading]=useState(api!==undefined);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState(false);
  const pending=useRef<{json:string;id:string}|null>(null);
  const inFlight=useRef(false);
  const refresh=useCallback(async()=>{
    if(api===undefined) return;
    const response=await api("/api/discovery/account");
    if(!response.ok) throw new Error("ACCOUNT_UNAVAILABLE");
    const next=accountSnapshotSchema.parse(await response.json());
    setSnapshot(next);setError(false);setLoading(false);
  },[api]);
  useEffect(()=>{ let active=true; if(api===undefined)return; void api("/api/discovery/account").then(async response=>{
    if(!response.ok)throw new Error("ACCOUNT_UNAVAILABLE");
    const next=accountSnapshotSchema.parse(await response.json());
    if(active){setSnapshot(next);setError(false);setLoading(false);}
  }).catch(()=>{if(active){setError(true);setLoading(false);}}); return()=>{active=false;}; },[api]);
  async function perform(command:AccountCommand) {
    if(api===undefined||inFlight.current)throw new Error("ACCOUNT_NOT_READY");
    inFlight.current=true;setBusy(true);
    const json=JSON.stringify(command);
    if(pending.current?.json!==json)pending.current={json,id:crypto.randomUUID()};
    const request=pending.current;
    try {
      const ack=await sendAccountCommand(api,command,request.id);
      await refresh();pending.current=null;return ack;
    } catch(error:unknown){setError(true);throw error;}
    finally{inFlight.current=false;setBusy(false);}
  }
  return {snapshot,loading,busy,error,perform,refresh};
}
export type DiscoveryAccount = ReturnType<typeof useDiscoveryAccount>;
